var ETranslateOption = /*#__PURE__*/ function(ETranslateOption) {
    ETranslateOption["Copy"] = "copy";
    ETranslateOption["Translate"] = "translate";
    ETranslateOption["Skip"] = "skip";
    ETranslateOption["Hidden"] = "hidden";
    return ETranslateOption;
}(ETranslateOption || {});
export { ETranslateOption };
